export class ExtendableError extends Error {
  public message: string;
  public name: string;

  constructor(message: string) {
    super();
    this.message = message;
    this.name = this.constructor.name;

    Object.setPrototypeOf(this, new.target.prototype);
  }
}
